export default function (http) {
    return {
        query (data){
            return http.json({
                url: '/trade/tax/query',
                data
            });
        },
        save(data){
            return http.json({
                url: '/trade/tax/save',
                data
            });
        },
        getInfo(data){
            return http.json({
                url: '/trade/tax/getOne',
                data
            });
        },
        delete(data){
            return http.json({
                url: '/trade/tax/delete',
                data
            })
        },
        confirm(data){
            return http.json({
                url: '/trade/tax/confirm',
                data
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/tax.js